import { Construction } from 'lucide-react';
import { STATE_META } from '@/components/tables/tableStates';
import { FloorUnit } from '../floor/FloorUnit';

// Alquileres de playa: SOLO prototipo visual para super_admin, sin backend ni datos reales
const SAMPLE = Array.from({ length: 12 }, (_, i) => ({
  unit_id: `demo-c${i + 1}`, name: `C${i + 1}`, forma: 'carpa', capacity: 6,
  state: ['free', 'occupied', 'reserved', 'free', 'occupied', 'to_clean'][i % 6],
  position_x: 14 + (i % 4) * 24, position_y: 28 + Math.floor(i / 4) * 28,
}));

export default function RentalsPrototype() {
  return (
    <div className="min-h-screen bg-background text-foreground p-4 md:p-6 space-y-4" data-testid="rentals-prototype">
      <div className="flex items-center gap-2 rounded-lg bg-[#fef3c7] text-[#78350f] px-4 py-2 font-semibold"><Construction className="w-5 h-5" />Prototipo · datos de ejemplo, no se guarda nada</div>
      <h1 className="text-2xl font-bold">Alquileres de temporada</h1>
      <div className="flex flex-wrap gap-4 text-sm">
        {['free', 'occupied', 'reserved', 'to_clean'].map(s => <span key={s} className="inline-flex items-center gap-1.5"><span className="w-3 h-3 rounded-full" style={{ background: STATE_META[s].color }} />{{ free: 'Disponible', occupied: 'Alquilada', reserved: 'Reservada', to_clean: 'Mantenimiento' }[s]}</span>)}
      </div>
      <div className="grid lg:grid-cols-[1fr_320px] gap-4">
        <div className="relative h-[520px] rounded-2xl overflow-hidden mtex-arena">
          {SAMPLE.map(u => <FloorUnit key={u.unit_id} unit={u} now={Date.now()} selected={u.name === 'C7'} />)}
        </div>
        <aside className="m-card p-4 space-y-2 text-sm">
          <h2 className="text-xl font-bold">Carpa C7</h2>
          {[['Plan', 'Temporada completa'], ['Titular', 'Familia Pérez'], ['Desde', '01/12/2025'], ['Hasta', '28/02/2026'], ['Pagado', '$ 420.000'], ['Saldo', '$ 180.000']].map(([k, v]) => (
            <div key={k} className="flex justify-between"><span className="text-muted-foreground">{k}</span><b>{v}</b></div>
          ))}
        </aside>
      </div>
    </div>
  );
}
